import { SubtitleSection } from "@domain/lms/article/article";
import { SectionController } from "@ui/pages/lms/article/articleEditorPage/sectionEditor/sectionController";
export class SubtitleSectionController extends SectionController<SubtitleSection> {
	setTitle(title: string): void {
		this.sectionUpdater((section) => ({ ...section, title }));
	}
}
